import React, { useEffect } from "react";
import "../main/assets/styles/landingCards.scss";
import ArrowButton from "./arrowButton";

const LandingCards = ({
  title,
  subtitle,
  button,
  backImg,
  mobBackImg,
  logo,
  onClick,
  priority,
  isLazyLoading,
}) => {
  useEffect(() => {
    if (priority === true && backImg) {
      const preLoadImage = document.createElement("link");
      preLoadImage.rel = "preload";
      preLoadImage.href = backImg;
      preLoadImage.as = "image";
      // document.head.appendChild(preLoadImage);
      const firstHeadElement = document.head.firstChild;

      // Insert the new link element before the first child of the head element
      document.head.insertBefore(preLoadImage, firstHeadElement);
    }
  }, [priority, backImg]);

  return (
    <>
      <div className="card landing-card">
        {backImg && (
          <>
            <img
              fetchPriority={priority === true ? "high" : "low"}
              loading={isLazyLoading === true ? "lazy" : "auto"}
              src={backImg}
              alt="backImg"
              className="back-img "
            />
          </>
        )}
        <div className="card-overlay"></div>
        <div className="card-body">
          {logo && (
            <img
              fetchPriority={priority === true ? "high" : "low"}
              loading={isLazyLoading === true ? "lazy" : "auto"}
              src={logo}
              alt="icon"
              className="card-icon"
            />
          )}
          <h3 className="card-title landing-cardTitle">{title}</h3>
          <p className="subtitle landing-cardSubTitle">{subtitle}</p>
          {button && <ArrowButton onClick={onClick} buttonTxt={button} />}
        </div>
      </div>
    </>
  );
};

export default LandingCards;
